import {FC} from 'react';

interface Props {
  fill?: string;
  size?: number;
}

export const OverviewIcon: FC<Props> = ({fill = '#000', size = 48}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9998 17.3333V22.75M12.9998 17.3333L19.4998 22.75M12.9998 17.3333L6.49984 22.75M22.7498 3.25V12.1333C22.7498 13.9535 22.7498 14.8636 22.3956 15.5588C22.084 16.1703 21.5868 16.6675 20.9753 16.9791C20.2801 17.3333 19.37 17.3333 17.5498 17.3333H8.44984C6.62967 17.3333 5.71958 17.3333 5.02437 16.9791C4.41284 16.6675 3.91565 16.1703 3.60407 15.5588C3.24984 14.8636 3.24984 13.9535 3.24984 12.1333V3.25M8.6665 9.75V13M12.9998 7.58333V13M17.3332 11.9167V13M23.8332 3.25H2.1665"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default OverviewIcon;
